import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "content"];

  connect() {
    const drawerElement = this.drawerTarget;
    const boUrl = drawerElement.dataset.url;
    const boBase = drawerElement.dataset.baseUrl;
    if (boUrl && boUrl.trim() !== "") {
      this.loadDrawer(boUrl, boBase);
    }
  }

  open(event) {
    event.preventDefault();

    const boUrl = event.currentTarget.dataset.url;
    const boBase = event.currentTarget.dataset.baseUrl;
    this.loadDrawer(boUrl, boBase);
  }

  loadDrawer(boUrl, boBase) {
    this.drawerTarget.classList.remove("hidden");

    fetch(boUrl, { headers: { "Accept": "text/html" } })
        .then((response) => {
          if (response.ok) {
            return response.text();
          }
        })
        .then((html) => {
          this.drawerTarget.innerHTML = html;
          history.pushState({}, "", boBase);
          this.bindContentEvents();
        });
  }

  close() {
    this.unbindContentEvents();
    this.drawerTarget.classList.add("hidden");

    const originalUrl = this.drawerTarget.dataset.adminUrl;
    if (originalUrl) {
      history.pushState({}, "", originalUrl);
    }
  }

  bindContentEvents() {
    const contentElement = this.drawerTarget;
    if (contentElement) {
      contentElement.addEventListener("click", this.handleContentClick.bind(this));
    }
  }

  unbindContentEvents() {
    const contentElement = this.drawerTarget;
    if (contentElement) {
      contentElement.removeEventListener("click", this.handleContentClick.bind(this));
    }
  }

  handleContentClick(event) {
    const contentElement = this.contentTarget;
    if (!contentElement.contains(event.target)) {
      event.preventDefault();
      this.close();
    }
  }
}
